import React from "react";
import { Container, Row } from 'react-bootstrap';
import './Projects.css';
import Project from "./Project";
import useData from "../hooks/useData";

const Projects = () => {
    const { projects } = useData();
    return (
        <div className="projects" id="Portfolio">
            <Container className="py-5">
                <div className="">
                    <h1 className="text-white mb-4">My Latest Project</h1>
                    {/* <p>There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration.</p> */}
                </div>
                <Row className="text-light my-4 g-4">
                    {
                        projects?.map(project => <Project
                            key={project?.id} project={project} />)
                    }
                </Row>
            </Container>
        </div>
    );
};

export default Projects;